import { AppDispatch, RootState } from '@app/store';

import { routingConfigVersionApi } from '../api';
import { IRoutingConfigVersionResponse } from '../model/types';

// The PATCH invalidates no tags and a refetch would show the page spinner, so the
// response is written into every cache entry showing the version: by-id, the lists
// (picker) and active (what the card renders without ?version). Only existing
// entries are touched — nothing is seeded for a page nobody is on.
export const applyVersionToCaches =
  (response: IRoutingConfigVersionResponse) =>
  (dispatch: AppDispatch, getState: () => RootState) => {
    const version = response.data;
    const { util } = routingConfigVersionApi;

    util.selectInvalidatedBy(getState(), ['RoutingConfigVersions']).forEach(entry => {
      if (entry.endpointName === 'getRoutingConfigVersions') {
        dispatch(
          util.updateQueryData('getRoutingConfigVersions', entry.originalArgs, draft => {
            const index = draft.data.findIndex(item => item.id === version.id);
            if (index !== -1) draft.data[index] = version;
          }),
        );
      } else if (entry.endpointName === 'getActiveRoutingConfigVersion') {
        dispatch(
          util.updateQueryData('getActiveRoutingConfigVersion', undefined, draft => {
            if (draft.data.id === version.id) draft.data = version;
          }),
        );
      } else if (
        entry.endpointName === 'getRoutingConfigVersion' &&
        entry.originalArgs === version.id
      ) {
        dispatch(
          util.updateQueryData('getRoutingConfigVersion', version.id, draft => {
            draft.data = version;
          }),
        );
      }
    });
  };
